import React from 'react'
import AmbulatoryMaterialsLayout from 'presentation/doctor/layouts/AmbulatoryMaterials'

function AmbulatoryMaterials() {
  return <AmbulatoryMaterialsLayout />
}

export default AmbulatoryMaterials
